import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';


//redux
import { useDispatch, useSelector } from 'react-redux';

import { Box, FormControlLabel, LinearProgress, Radio, RadioGroup, Typography } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import InfoIcon from '@material-ui/icons/Info';
import moment from 'moment';
import allActions from '../../../../../actions';
import { SuitabilitiesAPI } from '../../../../../API/suitabilities';
import { myLabelInput, unoTheme } from '../../../../../assets/styles/unoTheme';
import { getColorSuitability } from '../../../../../controllers/ClientController';
import UnoButton from '../../../../utils/UnoButton';
import { ClientAPI } from '../../../../../API/client';

const RESULTS_DESCRIPTIOS = {
    "CONSERVADOR": "Esse investidor prioriza, em alguns casos por necessidade, a estabilidade em suas aplicações e possui uma tolerância baixa ao risco. Dado o seu patrimônio relacionado às necessidades e obrigações, presentes e futuras, do seu RPPS, busca investimentos em ativos com liquidez e baixa volatilidade.",

    "MODERADO": "Esse investidor se posiciona entre os Conservadores e Agressivos. Ele preza por investimentos que proporcionem a segurança dos seus recursos e possui uma certa tolerância ao risco, buscando retornos acima da média no longo prazo. Possui um maior conhecimento de mercado e têm um patrimônio em crescimento.",

    "AGRESSIVO": "Esse investidor tem um amplo conhecimento sobre investimentos e boa tolerância ao risco. Ele lida bem com volatilidade no curto prazo em busca de maiores retornos no longo prazo. Possui um patrimônio consolidado e em crescimento podendo se expor em um grau maior a investimentos mais voláteis."
}

const useStyles = makeStyles((theme) => ({
    contentModal: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',

    },

    dialogTitleApr: {
        '& h2': {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            //justifyContent: 'space-between'
        }

    },

    dialogContent: {
        '& .MuiBox-root': {
            textAlign: 'center',
        },

    },

    green: {
        color: unoTheme.greenMoney,
    },
    red: {
        color: unoTheme.redMoney,
    },
    blue: {
        color: "blue",
    },
    warningColor: {
        color: unoTheme.warningColor
    },
    label: myLabelInput,
    afirmativeText: {
        color: 'black'
    },
    noPaddingLeft: {
        paddingLeft: '0px',
    },
    noPaddingRight: {
        paddingRight: '0px !important',
    },
    spacingRight2: {
        marginRight: theme.spacing(2),
    },

    questionary: {
        '& .question': {
            marginBottom: '24px',
            '& .option-question span': {
                fontSize: '14px !important'
            }
        }


    }
}));

function LinearProgressWithLabel(props) {
    return (
        <Box display="flex" alignItems="center">
            <Box width="100%" mr={1}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box minWidth={35}>
                <Typography variant="body2" color="textSecondary">{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

LinearProgressWithLabel.propTypes = {
    /**
     * The value of the progress indicator for the determinate and buffer variants.
     * Value between 0 and 100.
     */
    value: PropTypes.number.isRequired,
};

export default function SuitabilityQuestionaryModal(props) {

    const { handleCloseModal, open, clientOnScreen, setClientOnScreen } = props;

    const classes = useStyles();

    const dispatch = useDispatch();
    const history = useHistory();
    const currentUser = useSelector(state => state.currentUser);


    const [activeQuestionary, setActiveQuestionary] = useState();
    const [responses, setResponses] = useState([]);
    const [progress, setProgress] = React.useState(0);
    const [finished, setFinished] = React.useState(false);
    const [result, setResult] = React.useState(null);

    const handleChangeResponses = (indexQuestion, indexOption) => {
        console.log("indexQuestion, indexOption: ", indexQuestion, indexOption);
        const newResponses = [...responses];
        console.log("newResponses: ", newResponses);
        newResponses[indexQuestion] = indexOption;
        setResponses(newResponses);
    }

    const renderQuestionOptions = (options) => {

        const questionOptions = [];

        options.forEach((element, index) => {
            questionOptions.push(
                <FormControlLabel value={parseInt(index)} control={<Radio />} label={element} />
            )
        });

        return questionOptions;
    }

    const questions = useMemo(() => {

        if (!activeQuestionary) return [];

        const questionary = JSON.parse(activeQuestionary.questionary)
        const questionsArray = [];
        questionary.forEach((element, index) => {

            questionsArray.push(
                <div className='question'>
                    <Typography variant='h6' key={'question-' + index}>{(index + 1) + ". " + element.pergunta}</Typography>
                    <RadioGroup className='option-question' name={'options-question-' + index} value={parseInt(responses[index])} onChange={(_, value) => handleChangeResponses(index, value)}>
                        {renderQuestionOptions(element.opcoes)}
                    </RadioGroup>
                </div>
            )

        });

        const didResponses = responses.filter(el => el != null);
        setProgress(didResponses.length / questionary.length * 100);


        return questionsArray;
    }, [activeQuestionary, responses])

    const resumedResponses = useMemo(() => {

        if (!activeQuestionary) return [];

        const questionary = JSON.parse(activeQuestionary.questionary)
        const responsesQuestionsArray = [];
        questionary.forEach((element, index) => {

            responsesQuestionsArray.push(
                <div className='question'>
                    <Typography variant='h6' key={'question-response-title-' + index}>{(index + 1) + ". " + element.pergunta}</Typography>
                    <Typography variant='h6' style={{ color: "blue" }} key={'question-response-' + index}>RESPOSTA: {element.opcoes[parseInt(responses[index])]}</Typography>

                </div>
            )

        });


        return responsesQuestionsArray;
    }, [activeQuestionary, responses])

    const loadActiveQuestionary = async () => {
        const responseActiveQuestionary = await SuitabilitiesAPI.getActiveSuitabilitieQuestionary();
        if (responseActiveQuestionary.success && responseActiveQuestionary.body.rows.length == 1) {
            setActiveQuestionary(responseActiveQuestionary.body.rows[0]);
        }
    }

    const getSuitabilityResult = (resps) => {

        let points = 0;
        resps.forEach(element => {
            switch (element) {
                case "0": //A
                    points += 1;
                    break;
                case "1": //B
                    points += 2;
                    break;
                case "2": //C
                    points += 3;
                    break;
                case "3": //D
                    points += 4;
                    break;
                case "4": //E
                    points += 5;
                    break;

                default:
                    break;
            }
        });

        if (resps[0] == 0 //1A
            || resps[1] == 0 //2A
            || resps[2] == 0 //3A
            || resps[2] == 1 //3B
        ) {
            return {
                result: "CONSERVADOR",
                points,
            }
        }

        if (resps[1] == 2 //2C
            || resps[1] == 1 //2B
        ) {
            if (points <= 19) {
                return {
                    result: "CONSERVADOR",
                    points,
                }

            } else if (points >= 20) {
                return {
                    result: "MODERADO",
                    points,
                }
            }
        }

        if (points <= 19) {
            return {
                result: "CONSERVADOR",
                points
            }
        } else if (points >= 20 && points <= 29) {
            return {
                result: "MODERADO",
                points
            }
        } else if (points >= 30) {
            return {
                result: "AGRESSIVO",
                points
            }
        }
    }

    const doSaveSuitability = async (resps) => {

        const { result: r, points } = getSuitabilityResult(resps);
        const obj = {
            user_id: currentUser.user.id,
            client_id: clientOnScreen.id,
            suitability_questionary_id: activeQuestionary.id,
            response: JSON.stringify(resps),
            result: r,
            points: points
        }

        setResult(r);

        const responseSaveSuitability = await SuitabilitiesAPI.saveSuitability(obj);
        const responseUpdateSuitabilty = await ClientAPI.updateClientSuitability(clientOnScreen.id, r);
        setClientOnScreen({
            ...clientOnScreen,
            suitability: r,
        })

        console.log("responseUpdateSuitabilty: ", responseUpdateSuitabilty);

        if (responseSaveSuitability.success && responseUpdateSuitabilty.success) {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: 'Suitability salvo com sucesso!'
            }))
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: 'Falha ao salvar suitability!'
            }))

        }

        const scrollDiv = document.getElementById("suitability-dialog-content");
        console.log("scrollDiv: ", scrollDiv);
        if (scrollDiv) scrollDiv.scrollTop = 0;

        setFinished(true);
    }

    const clean = () => {
        setFinished(false);
        setActiveQuestionary(null);
        setProgress(0);
        setResponses([]);
    }

    useEffect(() => {
        if (open) {
            loadActiveQuestionary();
        } else {
            setTimeout(() => {

                clean()
            }, 500)
        }
    }, [open])

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'md'}
            open={open}
        //onClose={() => handleModalRatingUno(false)}
        >
            <DialogTitle
                className={classes.dialogTitleApr}>
                {
                    !finished ?
                        <><InfoIcon className={[classes.spacingRight2, classes.blue].join(' ')} />Questionário de Suitability</>
                        :
                        <><CheckIcon className={[classes.spacingRight2, classes.green].join(' ')} />Resultado da avaliação</>
                    // <><CheckIcon className={[classes.spacingRight2, classes.green].join(' ')} />Respostas da avaliação Suitability</>
                }


            </DialogTitle>


            {



                <DialogContent
                    id={"suitability-dialog-content"}
                    className={classes.dialogContent}>

                    {
                        !finished ?

                            <div>
                                <Typography style={{ textAlign: "justify" }}>Este questionário tem como objetivo coletar informações suficientes acerca da situação financeira, experiência e objetivos de investimentos do RPPS para permitir à LEMA a definição de seu perfil de risco e, desta forma, tornar o serviço de consultoria de investimentos mais aderente aos objetivos do RPPS. ACONSELHAMOS QUE ESTE QUESTIONÁRIO SEJA RESPONDIDO PELO GESTOR DE RECURSOS APÓS DISCUSSÃO JUNTO COM O COMITÊ DE INVESTIMENTOS DO RPPS</Typography>
                                <br />
                                <div className={classes.questionary}>
                                    {questions}
                                </div>
                            </div>
                            :

                            <div>
                                <Typography style={{ textAlign: "justify", fontWeight: "bold" }}>Você é: <span style={{ background: getColorSuitability(result), padding: "2px 16px", borderRadius: "20px", color: "white" }}>{result}</span></Typography>
                                <br />
                                <br />
                                <Typography style={{ textAlign: "justify", fontWeight: "bold" }}>Descrição do perfil</Typography>
                                <br />
                                <Typography style={{ textAlign: "justify" }}>{RESULTS_DESCRIPTIOS[result]}</Typography>
                            </div>


                    }
                </DialogContent>
            }





            {
                !finished ?
                    <DialogActions className={classes.actionsFlexRight}>



                        <div style={{ flex: 1, paddingLeft: '16px' }}>

                            <LinearProgressWithLabel value={progress} />
                        </div>

                        <UnoButton
                            onClick={() => handleCloseModal()} color="secondary">
                            {'Cancelar'}
                        </UnoButton>

                        <UnoButton
                            onClick={() => doSaveSuitability(responses)}
                            disabled={progress != 100}
                            color="primary">
                            {'Enviar'}
                        </UnoButton>
                    </DialogActions>
                    :

                    <DialogActions>
                        <UnoButton
                            onClick={() => handleCloseModal()} color="secondary">
                            {'Fechar'}
                        </UnoButton>
                    </DialogActions>
            }





        </Dialog >
    );
}